import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  signIn: {
    id: 'catalog.header.sign-in',
    defaultMessage: 'Sign in',
    description: 'Label for the sign-in button in the public catalog header.',
  },
  getStarted: {
    id: 'catalog.header.get-started',
    defaultMessage: 'Get started',
    description: 'Label for the primary CTA in the public catalog header.',
  },
  dashboard: {
    id: 'category.header.dashboard.label',
    defaultMessage: 'Dashboard',
    description: 'The text for the link to the Dashboard page.',
  },
  help: {
    id: 'category.header.help.label',
    defaultMessage: 'Help',
    description: 'The text for the link to the Help Center.',
  },
  courses: {
    id: 'category.header.course',
    defaultMessage: 'My Courses',
    description: 'The text for the link to the Courses page.',
  },
  exploreCourses: {
    id: 'category.header.explore-courses',
    defaultMessage: 'Explore courses',
    description: 'The text for the link to the Explore courses page.',
  },
  programs: {
    id: 'category.header.programs',
    defaultMessage: 'Programs',
    description: 'The text for the link to the Programs page.',
  },
  discoverNew: {
    id: 'category.header.discoverNew',
    defaultMessage: 'Explore',
    description: 'The text for the link to the Discover new page.',
  },
});

export default messages;
